function focusEl(e, direction) {
    var incrmental = 1;
    var resetPos = 0;    

    if (e.target.hasAttribute('data-shortcutelem')) {
        var modal = e.target.closest('.modal-content'); //if modal is open, work only on elements in there
        var inputs;
        if (modal != null) {
            inputs = $(modal.querySelectorAll('[data-shortcutelem]'));
        } else inputs = $(document.querySelectorAll('[data-shortcutelem]'));
        var lastIndex = inputs.length - 1;
        
        if (direction == 'previous') {
            incrmental *= -1;
            resetPos = lastIndex;
        }

        var currentIndex = inputs.index($(e.target));
        if ((resetPos == 0 && currentIndex == lastIndex) || (resetPos == lastIndex && currentIndex == 0))
            inputs[resetPos].focus();
        else inputs[currentIndex + incrmental].focus();
    }
}

function focusNext(e) {
    focusEl(e, 'next');
}

function focusPrevious(e) {
    focusEl(e, 'previous');
}
